import { render, staticRenderFns } from "./consumeRecord.vue?vue&type=template&id=0861e4e4&scoped=true&"
import script from "./consumeRecord.vue?vue&type=script&lang=js&"
export * from "./consumeRecord.vue?vue&type=script&lang=js&"
import style0 from "./consumeRecord.vue?vue&type=style&index=0&id=0861e4e4&lang=scss&scoped=true&"
import style1 from "./consumeRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0861e4e4",
  null
  
)

export default component.exports